import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, ValueObject } from '@digibricks/core';
export var ClientIdType = /*#__PURE__*/function (_ValueObject) {
  _inherits(ClientIdType, _ValueObject);

  var _super = _createSuper(ClientIdType);

  function ClientIdType() {
    _classCallCheck(this, ClientIdType);

    return _super.apply(this, arguments);
  }

  _createClass(ClientIdType, [{
    key: "value",
    get: function get() {
      return this.props;
    }
  }], [{
    key: "create",
    value: function create(value) {
      return Result.ok(new ClientIdType(value));
    }
  }, {
    key: "contain",
    value: function contain(value) {
      var hasContainClientId = this.resources.includes(value);

      if (!hasContainClientId) {
        return Result.fail("Client Id type: ".concat(value, " not existed"));
      }

      return Result.ok();
    }
  }]);

  return ClientIdType;
}(ValueObject);

_defineProperty(ClientIdType, "resources", ['teacher', 'student']);

_defineProperty(ClientIdType, "teacher", ClientIdType.create(ClientIdType.resources[0]).getValue());

_defineProperty(ClientIdType, "student", ClientIdType.create(ClientIdType.resources[1]).getValue());